import { TtsService } from './TtsService';

/**
 * Web Speech API Implementation
 */
export class WebSpeechTtsService extends TtsService {
  async speak(text, options = {}) {
    const { locale = 'ja' } = options;

    return new Promise((resolve) => {
      const utter = new SpeechSynthesisUtterance(text);
      utter.lang = locale === 'ja' ? 'ja-JP' : 'en-US';

      utter.onend = () => resolve();
      utter.onerror = (e) => {
        console.error('WebSpeech Error:', e);
        resolve(); // Resolve anyway to not hang
      };

      window.speechSynthesis.speak(utter);
    });
  }

  async stop() {
    window.speechSynthesis.cancel();
  }
}
